export default {
  CREATE: `Créer une équipe`,
  DELETE_BUTTON: {
    TITLE: `Supprimer l'équipe`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette équipe ?`,
    PRIMARY_ACTION: `Supprimer l'équipe`,
    BAD_MATCH: `La saisie ne correspond pas au mot "SUPPRIMER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    DELETE: {
      LABEL: `Entrez "SUPPRIMER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Liste des équipes`
  },
  DESCRIPTION: `Description`,
  REPORTS_TO: `Gérée par`,
  POSITIONS: `Positions`,
  CSV_EXPORT_NAME: `export_equipes_{{date}}`,
  WILL_BE_IMPACTED: `Nombre de personnes impactées (désassignées)`,
  AFFECTED_USERS: `Utilisateurs affectés`,
  form: {
    CREATE: {
      TITLE: `Créer une équipe`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modifier une équipe`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom de l'équipe`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement la repérer.`,
      PLACEHOLDER: `Entrez un nom pour l'équipe`
    },
    DESCRIPTION: {
      LABEL: `Description de l'équipe`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez une description pour l'équipe`
    },
    IMPORTCODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Le code d'importation sert à pouvoir assigner des équipes à d'autres ressources avec les outils d'importation.`,
      PLACEHOLDER: `Entrez le code d'importation`
    },
    REPORTSTO: {
      LABEL: `Gérée par`,
      DESCRIPTION: `Les notifications relatives à cette équipe seront envoyées à cet utilisateur.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      DESCRIPTION: `Ces positions seront affichées par défaut dans la vue par équipe.`
    },
    NAME_REQUIRED: `Le nom de l'équipe est obligatoire.`,
    NAME_ALREADY_USED: `Le nom est déjà utilisé.`
  }
}
